import React, { Component } from "react";
import * as yup from "yup";
import moment from "moment-timezone"; 
import Modal from "antd/lib/modal/Modal";
import { isUndefined, map } from "lodash";
import { Drawer, message, Select } from "antd";
import Loader from "../../../../Common/Component/Loader";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

const { Option } = Select;
class LogPayment extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      log_type: '',
      payment_log: {
        cash_payment: false,
        cheque_payment: false,
        is_check: false,
        received_from: '',
        amount_received: '',
        cheque_id: '',
        user_uuid: '',
        received_by_uuid: '',
        invoice_uuid: ''
      },
      staffList: {},
      errors: {},
      card_payment_type: 1,
      new_card_uuid: '',
      is_card_payment: false,
      id_old_card: false,
      franchise_uuid: '',
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      stax_customer_id : '',
      stax_public_apikey: null,
      hideAddNewButton: false,
      transaction_type: 'create',
      showSuccess: false,
      received_by_uuid: '',
      user_uuid: '',
      show_confirm: false,
      card_count:0
    }
  }

  componentDidMount = () => {
    let { payment_log, transaction_type } = this.state;
    const { customerId, invoice_uuid, customerList, payment } = this.props;
    let type = transaction_type;

    this.setState({loader: true});
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const associated_field_offices = authUser?.user?.associated_field_offices?.map(x => x.uuid);

    if (this.props.edit)
    {
      type = 'edit';
      const payment_log_data = {
        cash_payment: payment?.payment_type === "Cash" ? true : false,
        cheque_payment: payment?.payment_type === "Check" ? true : false,
        received_from: payment?.received_from,
        amount_received: payment?.amount_received,
        user_uuid: customerId,
        invoice_uuid: payment?.invoice_uuid,
        is_check: payment?.payment_type === 'Check' ? true : false,
        cheque_id: payment?.check_id,
        uuid: payment.uuid,
        received_by: payment?.received_by?payment?.received_by:`${authUser?.user.first_name} ${authUser?.user.last_name}`,
        received_by_uuid: authUser?.user?.uuid
      };
      
      this.setState({
        transaction_type: 'edit',
        payment_log: payment_log_data,
        franchise_uuid: associated_field_offices?.[0],
        log_type: payment?.payment_type === "Cash" ? "cash" : "cheque"
      });
    }
    else
    {
      payment_log = Object.assign(payment_log, {
        user_uuid: customerId,
        invoice_uuid,
        received_by: `${authUser?.user.first_name} ${authUser?.user.last_name}`,
        received_by_uuid: authUser?.user?.uuid
      });
      this.setState({payment_log, franchise_uuid: associated_field_offices?.[0]});
      
      if(type === 'create')
      {
        //Get User card list
        this.props.getCardList({ user__uuid: customerId });
        this.props.getInvoiceSummary({ user__uuid: customerId });
        
        if (Object.keys(customerList).length > 0) {
          this.setState({ 
            stax_customer_id : customerList?.customer?.stax_customer,
            stax_public_apikey: customerList?.customer?.field_office?.stax_public_apikey,
            hideAddNewButton : customerList?.customer?.field_office?.stax_public_apikey ? false : true
          })
        }
      }
    }
    
    this.props.getStaffUsers({ staff_profile__field_office__uuid: associated_field_offices?.[0], invoice_list: true });
  }

  componentDidUpdate() {
    if(this.state.showSuccess)
    {
      setTimeout(() => this.setState({showSuccess: false}), 5000);  
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { payment_log, transaction_type } = this.state;
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    // Get staff list
    if (nextProps?.Invoice && Object.keys(nextProps?.Invoice?.staffList).length > 0) {
      if(JSON.stringify(this.props.Invoice?.staffList) !== JSON.stringify(nextProps?.Invoice?.staffList) || 
        isUndefined(this.props?.payment_log?.received_by_uuid))
      {
        if(transaction_type === 'edit')
        {
          let received_by = nextProps?.Invoice?.staffList?.results?.filter(
            (staff) => `${staff.first_name} ${staff.last_name}`.trimEnd() === this.props.payment.received_by)[0];
          const temp_payment_log = {...payment_log,  received_by_uuid: received_by?.uuid?received_by?.uuid:authUser?.user?.uuid
          };
  
          this.setState({
            staffList: nextProps?.Invoice?.staffList,
            payment_log: temp_payment_log,
            loader: false,
          });
        }
        else
        {
          this.setState({
            staffList: nextProps?.Invoice?.staffList,
            loader: false
          });
        }
      }
    }

    if (nextProps.invoice_uuid && nextProps.invoice_uuid !== payment_log.invoice_uuid) {
      Object.assign(payment_log, { invoice_uuid: nextProps.invoice_uuid });
      this.setState({ payment_log, loader: false });
    }
    if(transaction_type === 'create')
    {
      //Get Cards dlist
      if (Object.keys(nextProps?.cardList?.data).length > 0 && nextProps?.cardList?.data !== this.props.cardList.data) {
        this.setState({
          card_list: nextProps.cardList.data.results,
          card_count:nextProps.cardList.data.count,
          loader: false
        })
      }
  
      if (Object.keys(nextProps?.cardList?.errors).length > 0 && nextProps?.cardList?.errors !== this.props.cardList?.errors) {
        this.setState({ loader: false });
      }
  
      //Add new card
      if (Object.keys(nextProps?.addCard?.data).length > 0 && nextProps?.addCard?.data !== this.props.addCard?.data) {
        this.setState({
          new_card_uuid: nextProps?.addCard?.data?.uuid
        }, () => {
          this.addPaymentLog();
        })
      }
  
      if (Object.keys(nextProps?.addCard?.errors).length > 0 && nextProps?.addCard?.errors !== this.props.addCard?.errors) {
        this.setState({ loader: false });
      }
    }

    if (Object.keys(nextProps?.addedLog?.data).length > 0 && nextProps?.addedLog?.data !== this.props.addedLog?.data) {
      this.props.toggleLoader(false);
      this.props.getInvoiceList();
      this.props.getInvoiceSummary({ user__uuid: nextProps?.customerId });
      this.closeAndClear();
    }

    if (Object.keys(nextProps.addedLog.errors).length > 0 && nextProps.addedLog.errors !== this.props.addedLog.errors) {
      this.setState({ loader: false });
    }

    if (nextProps && nextProps?.customer && Object.keys(nextProps?.customer).length > 0) {
      let payment_log = Object.assign(this.state.payment_log, { received_from: `${nextProps?.customer?.first_name} ${nextProps?.customer?.last_name}` });
      if(transaction_type !== 'edit')
      {
        this.setState({ payment_log });
      }
    }

    if (this.state.hideAddNewButton && this.props.manualLog) {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }

    if (nextProps && nextProps?.PostPaymentLog && Object.keys(nextProps?.PostPaymentLog.data).length > 0) {
      this.setState({loader : false });
      this.closeAndClear();
      this.props.onUpdated(true);
    }
    
    if(nextProps?.PostPaymentLog && Object.keys(nextProps?.PostPaymentLog.errors).length > 0 
      && nextProps.PostPaymentLog.errors !== this.props.PostPaymentLog.errors) {
      this.setState({loader : false });
      this.closeAndClear();
      this.props.onUpdated(false);
    }

    this.setState({ loader: false });
  }

  // Validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  //Payment type change
  onLogTypeChange = (e) => {
    let { payment_log,card_count } = this.state;
    let authUser = JSON.parse(localStorage.getItem('authUser'));

    payment_log = Object.assign(payment_log,
      {
        cash_payment: false,
        cheque_payment: false,
        received_from: `${this.props?.customer?.first_name} ${this.props?.customer?.last_name}`,
        amount_received: '',
        cheque_id: '',
        received_by_uuid: authUser?.user?.uuid || '',
        received_by: `${authUser?.user.first_name} ${authUser?.user.last_name}`,
        is_check: e.target.id === 'cheque'
      }
    )

    this.setState({
      log_type: e.target.id,
      payment_log,
      errors: {}
    })
    if (e.target.id === 'card') {
      this.setState({
        id_old_card: true
      })
      if(card_count===0){
        this.setState({
          card_payment_type: 0,
          is_card_payment: true,
          id_old_card: false,
        });
        this.loadStax();
      }
    }
    else {
      this.setState({
        id_old_card: false
      })
    }
  }

  // On log text change
  onTextChange = (e) => {
    let { payment_log } = this.state;
    payment_log = Object.assign(payment_log, { [e.target.name]: e.target.value });

    this.setState({payment_log});
  }

  // On search received by
  onSearchReceivedBy = (search) => {
    if (search?.length === 0 || search?.length >= 3) {
      this.props.getStaffUsers({ search: search, staff_profile__field_office__uuid: this.state.franchise_uuid, invoice_list: true })
    }
  }

  //Receive by
  onReceiveChange = (e) => {
    let { payment_log } = this.state;
    payment_log = Object.assign(payment_log, { 'received_by_uuid': e });

    this.setState({ payment_log });
  }

  validateBalance = () => {
    const { payment_log, invoice_summary } = this.state;
    const currentBalance = invoice_summary?.total_open_balance;

    if(currentBalance - payment_log.amount_received < 0) {
      this.toggleConfirmModal();
    }
    else {
      this.validateLog();
    }
  }

  // validate required fields
  validateLog = () => {
    const { 
      payment_log,
      log_type,
      card_payment_type,
      is_card_payment,
      new_card_uuid,
      id_old_card,
      card_number,
      card_expiry_month,
      card_expiry_year,
      card_cvv,
      invoice_summary,
      received_by_uuid,
      transaction_type 
    } = this.state;
    const is_manual_log = this.props.manualLog;

    if (log_type === 'card' && card_payment_type === 0) {
      const PaymentSchema = yup.object().shape({
        card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
        card_expiry_month : yup.string().nullable().required('Card expire month is required'),
        card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4,
          'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
        card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
        log_type: yup.string().required('Log type is required'),
        payment_log: yup.object().shape({
          received_from: yup.string().required("Received from is required"),
          amount_received: yup.string().required("Amount received is required"),
          user_uuid: yup.string().required("user_uuid is required"),
          received_by_uuid: yup.string().required("Received by is required"),
          cheque_id: yup.string().when('is_check', {
            is: true,
            then: yup.string().required('Check id is required'),
          }),
          invoice_uuid: yup.string().when('is_manual_log', {
            is: false,
            then: yup.string().required("Invoice id is required")
          }),
        }),
        is_card_payment: yup.bool(),
        id_old_card: yup.bool(),
        new_card_uuid: yup.string().when('id_old_card', {
          is: true,
          then: yup.string().required("Card is required"),
        }),
      });

      const cardData = { 
        payment_log,
        log_type,
        is_card_payment,
        id_old_card,
        new_card_uuid,
        card_number,
        card_expiry_month,
        card_expiry_year,
        card_cvv
      };
      
      PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({ errors: {} });
        this.addNewCard();
      }).catch((error) => { 
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    } else {
      const PaymentSchema = yup.object().shape({
        log_type: yup.string().required('Log type is required'),
        payment_log: yup.object().shape({
          received_from: yup.string().required("Received from is required"),
          amount_received: yup.string().required("Amount received is required"),
          user_uuid: yup.string().required("user_uuid is required"),
          received_by_uuid: yup.string().required("Received by is required"),
          cheque_id: yup.string().when('is_check', {
            is: true,
            then: yup.string().required('Check id is required'),
          }),
          invoice_uuid: yup.string().when('is_manual_log', {
            is: false,
            then: yup.string().required("Invoice id is required")
          }),
        }),
        is_card_payment: yup.bool(),
        id_old_card: yup.bool(),
        new_card_uuid: yup.string().when('id_old_card', {
          is: true,
          then: yup.string().required("Card is required")
        }),
      });

      const cardData = { payment_log, log_type, is_card_payment, id_old_card, new_card_uuid };
      PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({ errors: {} });

        if(transaction_type !== 'edit')
        {
          this.addPaymentLog();
        }
        else
        {
          this.updatePaymentLog();
        }

      }).catch((error) => { 
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }
  }

  toggleConfirmModal = () => {
    this.setState({show_confirm: !this.state.show_confirm});
  }

  renderModal = () => {
    return <Modal
      title="Negative balance"
      visible={this.state.show_confirm}
      onCancel={() => this.toggleConfirmModal()}
      className=""
      width={400}
      footer={[
        <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.toggleConfirmModal()}>Cancel</button>,
        <button key="upload" className={`btn btn-waning`} onClick={() => {
          this.validateLog();
          this.toggleConfirmModal();
        }}>Log Payment</button>,
      ]}
    >
      <div>
        <p> Are you sure you would like to log this payment and create a negative balance on the account?</p>
      </div>
    </Modal>
  }

  // Add new card
  addNewCard = () => {
    const { card_expiry_month, card_expiry_year, card_number } = this.state;
    const { customer } = this.props.customerList;
    this.setState({ loader : true });
    const token_obj = {
      address_1: customer ? customer.billing_address[0].address : null,
      address_city: customer ? customer.billing_address[0].city : null,
      address_state: customer ? customer.billing_address[0].state : null,
      address_zip: customer ? customer.billing_address[0].zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: customer && customer.email ? customer.email : null,
      firstname: customer && customer.first_name ? customer.first_name : null,
      lastname: customer && customer.last_name ? customer.last_name : null,
      method: 'card',
      person_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
      phone: this.state.card_phone
    }
    if (this.state.stax_customer_id) {
      token_obj['customer_id'] = this.state.stax_customer_id
    }
    this.fattJs.tokenize(token_obj).then((res) => {
      if (res && Object.keys(res).length > 0) {
        if (!customer.billing_address[0].geo_location) {
          delete customer.billing_address[0].geo_location
        }
        this.props.addNewCard({
          user_uuid: customer ? customer.uuid : null,
          address: customer ? customer.billing_address[0] : null,
          stax_card_token : res['id'] || null,
          card_holder_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
        });
      }
    }).catch((err) => {
      console.error("Error : ",err);
      this.setState({ loader : false })
      map(err.fieldErrors, (item) => {
        message.error(item.message,10)
      });
      message.error(err.message,10);
    });
  }

  updatePaymentLog = () => {
    let { payment_log, log_type, new_card_uuid } = this.state;
    let { received_from, received_by_uuid, user_uuid, amount_received, cheque_id, invoice_uuid, uuid } = payment_log;

    this.setState({ loader : true });

    let data = {
      cash_payment: log_type === 'cash' ? true : false,
      cheque_payment: log_type === 'cheque' ? true : false,
      cc_auto_payment: log_type === 'card' ? true : false,
      received_from,
      amount_received: parseFloat(amount_received).toFixed(2),
      user_uuid,
      uuid,
      received_by_uuid,
      cheque_id,
      invoice_uuid
    }
    if (log_type === 'cash') {
      delete data.cheque_id;
      delete data.user_billing_info;
    }
    if (log_type === 'check') {
      delete data.user_billing_info;
    }
    if (log_type === 'card') {
      delete data.cheque_id
      data.user_billing_info = new_card_uuid;
    }

    this.props.postPaymentLog(data);
  }

  //Add Log Payment Log
  addPaymentLog = () => {
    let { payment_log, log_type, new_card_uuid } = this.state;
    let { received_from, received_by_uuid, user_uuid, amount_received, cheque_id, invoice_uuid } = payment_log
    let data = {
      cash_payment: log_type === 'cash' ? true : false,
      cheque_payment: log_type === 'cheque' ? true : false,
      cc_auto_payment: log_type === 'card' ? true : false,
      received_from,
      amount_received: parseFloat(amount_received).toFixed(2),
      total:parseFloat(amount_received).toFixed(2),
      remaining_balance:parseFloat(amount_received).toFixed(2),
      pay_method:log_type === 'cash'?"CASH":log_type === 'cheque'?"CHEQUE":"CARD",
      user_uuid,
      received_by_uuid,
      processed_by_uuid:received_by_uuid,
      cheque_id,
      invoice_uuid,
      date_unattachedpayment:moment().format('YYYY-MM-DD')
    }
    if (this.props.manualLog) {
      delete data.invoice_uuid;
    }
    if (log_type === 'cash') {
      delete data.cheque_id;
      delete data.user_billing_info;
    }
    if (log_type === 'check') {
      delete data.user_billing_info;
    }
    if (log_type === 'card') {
      delete data.cheque_id
      data.user_billing_info = new_card_uuid;
      data.card_id=new_card_uuid;
    }
    if (this.props.manualLog){
      this.props.addUnattachedPayment(data).then(() => {
        if (this.props.manualLog)
        {
          this.closeAndClear();
          message.success("Your payment was log successfully");
          this.props.updateSummary(this.props.customerId);
        }
      });
    }else{
      this.props.addPaymentLog(data).then(() => {
        if (this.props.manualLog)
        {
          this.closeAndClear();
          message.success("Your payment was log successfully");
          this.props.updateSummary(this.props.customerId);
        }
        else
        {
          this.closeAndClear();
          message.success("Your payment was log successfully");
          console.log("Your payment was log successfully")
          this.props.updateSummary(this.props.customerId);
        }
      });
    }
  }

  // Clean drawer
  clear = () => {
    let { payment_log } = this.state;

    payment_log = Object.assign(payment_log,
      {
        cash_payment: false,
        cheque_payment: false,
        received_from: '',
        amount_received: '',
        cheque_id: '',
        received_by_uuid: '',
        is_check: false
      }
    )
    this.setState({
      payment_log,
      log_type: '',
      errors: {},
      loader: false
    })
  }

  //Close drawer and clear value
  closeAndClear = () => {
    this.props.closeDrawer(false);
    this.clear();
  }

  // Load Stax
  loadStax = () => {
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded', handler);
      }).catch(err => {
        console.error('error occur', err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  }

  //Render cash block
  renderCashBlock = () => {
    const { log_type, payment_log, staffList, errors, transaction_type } = this.state;

    return (
      <div className={log_type === 'cash' ? 'form-group  log_card  mb-20' : 'form-group'}>
        <div className="fitem">
          <div className="fitem-check">
            <input
              id="cash"
              type="radio"
              className="fitem-ck-input"
              checked={log_type === 'cash'}
              onChange={(e) => { this.onLogTypeChange(e) }}
              name="cash" />
            <label htmlFor="cash" className="fitem-ck-txt">Cash Payment</label>
          </div>
        </div>
        {log_type === 'cash' ?
          <div className="p-30">
            <div className="fitem text_with_place amount ">
              <label>Amount Received</label>
              <div style={{"position": "relative"}}>

                <input type="text"
                  className="twhite"
                  name="amount_received"
                  value={payment_log.amount_received}
                  onChange={(e) => formatToCurrency(e.target.value) && this.onTextChange(e)}
                  onPaste={(event) => {
                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="0.00"
                />
              </div>
              {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
              {errors?.['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.amount_received']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Received From</label>
              <input type="text"
                className="twhite"
                name="received_from"
                value={payment_log.received_from}
                onChange={(e) => { this.onTextChange(e) }}
                placeholder="" />
              {errors?.['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.received_from']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Received By</label>
              <Select
                showSearch
                filterOption={false}
                value={this.state.payment_log?.received_by_uuid}
                onChange={(e) => { this.onReceiveChange(e) }}
                onSearch={(e) => this.onSearchReceivedBy(e)}
                onBlur={() => this.onSearchReceivedBy()}
                className="swhite">
                <Option value={this.state.payment_log?.received_by_uuid}>
                  {this.state.payment_log?.received_by}
                </Option>
              </Select>
              {errors?.['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.received_by_uuid']}</label> : ''}
            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderChequeBlock = () => {
    const { log_type, payment_log, staffList, errors, transaction_type } = this.state;

    return (
      <div className={log_type === 'cheque' ? 'form-group  log_card' : 'form-group'}>
        <div className="fitem">
          <div className="fitem-check">
            <input
              type="radio"
              className="fitem-ck-input"
              id="cheque"
              checked={log_type === 'cheque'}
              onChange={(e) => { this.onLogTypeChange(e) }}
              name="cheque" />
            <label htmlFor="cheque" className="fitem-ck-txt">Check Payment</label>
          </div>
        </div>
        {log_type === 'cheque' ?
          <div className="p-30">
            <div className="fitem text_with_place amount">
              <label>Amount Received</label>
              <div style={{"position": "relative"}}>
                <input type="text"
                  className="twhite"
                  name="amount_received"
                  value={payment_log.amount_received}
                  onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}
                  onPaste={(event) => {
                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="0.00"
                />
              </div>
              {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
              {errors?.['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.amount_received']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Received From</label>
              <input type="text"
                className="twhite"
                name="received_from"
                value={payment_log.received_from}
                onChange={(e) => { this.onTextChange(e) }}
                placeholder="" />
              {errors?.['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.received_from']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Check ID #</label>
              <input type="text"
                className="twhite"
                name="cheque_id"
                value={payment_log.cheque_id}
                onChange={(e) => { this.onTextChange(e) }}
                onPaste={(event) => {
                  if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                    event.preventDefault();
                  }
                }}
                onKeyPress={(e) => {
                  const pattern = /[0-9]/;
                  const inputChar = String.fromCharCode(e.charCode);
                  if (!pattern.test(inputChar)
                  ) {
                    // invalid character, prevent input
                    e.preventDefault();
                  }
                }}
                placeholder="" />
              {errors?.['payment_log.cheque_id'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.cheque_id']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Received By</label>
              <Select
                showSearch
                filterOption={false}
                value={this.state.payment_log?.received_by_uuid}
                onChange={(e) => { this.onReceiveChange(e) }}
                onSearch={(e) => this.onSearchReceivedBy(e)}
                onBlur={() => this.onSearchReceivedBy()}
                defaultValue=""
                className="swhite">
                <Option value={this.state.payment_log?.received_by_uuid}>
                  {this.state.payment_log?.received_by}
                </Option>
              </Select>
              {errors?.['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.received_by_uuid']}</label> : ''}
            </div>
          </div>
          : ''}
      </div>
    )
  }

  //Render Card Block
  renderCardBlock = () => {
    const { log_type, payment_log, staffList, errors, card_payment_type, new_card_uuid, card_list } = this.state;
    return (
      <div className={log_type === 'card' ? 'form-group  log_card' : 'form-group'}>
        <div className="fitem">
          <div className="fitem-check">
            <input
              type="radio"
              className="fitem-ck-input"
              id="card"
              checked={log_type === 'card'}
              onChange={(e) => { this.onLogTypeChange(e) }}
              name="card" />
            <label htmlFor="card" className="fitem-ck-txt">Card Payment</label>
          </div>
        </div>

        {log_type === 'card' ?
          <div className="p-30">
            <div className="fitem text_with_place amount">
              <label>Amount Received</label>
              <div style={{"position": "relative"}}>
                <input type="text"
                  className="twhite"
                  name="amount_received"
                  value={payment_log.amount_received}
                  onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}
                  onPaste={(event) => {
                    if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="0.00"
                />
              </div>
              {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
              {errors?.['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.amount_received']}</label> : ''}
            </div>
            <div className="fitem">
              <label>Received From</label>
              <input type="text"
                className="twhite"
                name="received_from"
                value={payment_log.received_from}
                onChange={(e) => { this.onTextChange(e) }}
                placeholder="" />
              {errors?.['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_log.received_from']}</label> : ''}
            </div>

            <div className="fitem half-fitem">
              <div className="fitem half-fitem inline-check-list">
                <div className="fitem-check">
                  <input
                    type="radio"
                    className="fitem-ck-input"
                    id="new_card"
                    checked={card_payment_type === 0}
                    onChange={() => {
                      this.setState({
                        card_payment_type: 0,
                        is_card_payment: true,
                        id_old_card: false
                      });
                      this.loadStax();
                    }}
                    name="card_type" />
                  <label htmlFor="new_card" className="fitem-ck-txt">Add New Card</label>
                </div>
              </div>

              <div className="fitem half-fitem inline-check-list">
                <div className="fitem-check">
                  <input
                    type="radio"
                    className="fitem-ck-input"
                    id="old_card"
                    checked={card_payment_type === 1}
                    onChange={() => {
                      this.setState({
                        card_payment_type: 1,
                        is_card_payment: false,
                        id_old_card: true
                      })
                    }}
                    name="card_type" />
                  <label htmlFor="old_card" className="fitem-ck-txt">Use Existing Card</label>
                </div>
              </div>
            </div>
            {card_payment_type === 1 ?
              <div className="fitem">
                <label>Card List</label>
                <Select
                  placeholder="Select Card"
                  filterOption={false}
                  value={new_card_uuid}
                  onChange={(e) => {
                    this.setState({
                      new_card_uuid: e
                    })
                  }}
                  className="swhite">
                  {map(card_list, (item) => {
                    return (
                      <Option key={item.uuid}>{item?.card_holder_name}-{JSON.parse(item?.stax_payment_object)?.card_last_four}</Option>
                    )
                  })}

                </Select>
                {errors['new_card_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_card_uuid']}</label> : ''}
              </div>
              :
              <React.Fragment>

                <div className="fitem">
                  <label>Card Number</label>
                  <div id="card-number" className="form--control twhite"></div>
                </div>

                <div className="fitem">
                  <label>CVV</label>
                  <div id="card-cvv" className="form--control twhite"></div>
                </div>

                <div className="fitem half-fitem">
                  <div className="fitem half-fitem">
                    <label>Expiration Month</label>
                    <input type="text" className="form--control twhite" placeholder="MM" maxLength={2} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                  </div>
                  <div className="fitem half-fitem">
                    <label>Expiration Year</label>
                    <input type="text" className="form--control twhite" placeholder="YYYY" maxLength={4} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                  </div>
                </div>
                
              </React.Fragment>
            }
            <div className="fitem">
              <label>Received By</label>
              <Select
                showSearch
                filterOption={false}
                value={this.state.payment_log?.received_by_uuid}
                onChange={(e) => { this.onReceiveChange(e) }}
                onSearch={(e) => this.onSearchReceivedBy(e)}
                onBlur={() => this.onSearchReceivedBy()}
                defaultValue=""
                className="swhite">
                <Option value={this.state.payment_log?.received_by_uuid}>
                  {this.state.payment_log?.received_by}
                </Option>
              </Select>
              {errors['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_by_uuid']}</label> : ''}
            </div>
          </div>
          : ''}
      </div>

    )
  }

  render() {
    const { visible, payment } = this.props;
    const { errors, loader, transaction_type, showSuccess } = this.state;

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.closeAndClear()}
        visible={visible}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer log_payment_drawer">
          <div className="card-row">
            <div className="card-full">
              {loader && <Loader/>}
              <h4>{`${ transaction_type === 'create' ? 'Log Manual Payment' : 'Edit Payment'}`}</h4>
              { (transaction_type !== 'edit' || payment.payment_type === "Cash") && this.renderCashBlock()}
              { (transaction_type !== 'edit' || payment.payment_type === "Check") && this.renderChequeBlock()}
              { transaction_type !== 'edit' && this.renderCardBlock()}
              {errors?.['log_type'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['log_type']}</label> : ''}
            </div>
            {
              showSuccess ?
                <div style={{
                  display: "flex",
                  flexDirection: "row",
                  position: "fixed",
                  width: "350px",
                  zIndex: "9",
                  justifyContent: "center",
                  bottom: "100px",

                }}>
                  <div className="fitem-ricon">
                    <i style={{fill: "green"}} className="las la-check"></i>
                  </div>
                  <span style={{marginLeft: "15px"}}>Your payment was successfully added</span>
                </div> : null
            }

            <div className="footer" style={{ 'width': '400px' }}>
              <button
                className="btn btn-brand btn-bdr"
                onClick={() => {
                  this.closeAndClear()
                }}
              >Cancel</button>
              <button
                // disabled={!is_btn_active}
                className={`btn btn-warning`}
                onClick={() => this.validateLog()}
              >{ transaction_type === 'create' ? 'Log Payment' : 'Update Payment'}</button>
            </div>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default LogPayment;